const RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION = {
    error: 'LENGTH_DOCUMENT_ERROR',
    valid: false
}
const RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION = {
    error: 'PATTERN_DOCUMENT_ERROR',
    valid: false
}
const RESPONSE_OK_DOCUMENT_VALIDATION = {
    valid: true
}

module.exports = {
    RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION,
    RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION,
    RESPONSE_OK_DOCUMENT_VALIDATION
};